import cn from 'classnames';
import { ChangeEvent, ReactNode } from 'react';
import styles from './radio-button.module.scss';

export interface IRadioButtonProps {
  content: ReactNode;
  name: string;
  id: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  iconVariant?: 'none' | 'stroke' | 'fill';
  withBorder?: boolean;
  value?: string;
  checked?: boolean;
  checkbox?: boolean;
  className?: string;
}

const RadioButton = ({
  content,
  className = '',
  checkbox = false,
  iconVariant = 'none',
  withBorder = false,
  ...rest
}: IRadioButtonProps): JSX.Element => {
  /* ClassNames */

  const labelClasses: string = cn(styles.radio, className, {
    [styles.withBorder]: withBorder,
  });
  const inputClasses: string = cn(styles.input, {
    [styles.fill]: iconVariant === 'fill',
    [styles.stroke]: iconVariant === 'stroke',
  });

  return (
    <>
      <input
        className={inputClasses}
        type={checkbox ? 'checkbox' : 'radio'}
        {...rest}
      />
      <label htmlFor={rest.id} className={labelClasses}>
        {content}
      </label>
    </>
  );
};

export default RadioButton;
